import { render } from "./MyAssets.vue?vue&type=template&id=08f6bfea&scoped=true"
import script from "./MyAssets.vue?vue&type=script&lang=js"
export * from "./MyAssets.vue?vue&type=script&lang=js"

import "./MyAssets.vue?vue&type=style&index=0&id=08f6bfea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f6bfea"]])

export default __exports__